import Swal from "sweetalert2";
import { Rename_Title_Edit_history_Api } from "../../Apis/user/ApiConfig";
import {
  RENAME_TITLE_EDIT_HISTORY_ERROR,
  RENAME_TITLE_EDIT_HISTORY_REQUEST,
  RENAME_TITLE_EDIT_HISTORY_SUCCESS,
} from "../../Types/user/Types";

export const Rename_Title_edit_History_Success = (res) => {
  return {
    type: RENAME_TITLE_EDIT_HISTORY_SUCCESS,
    payload: res,
  };
};
export const Rename_Title_edit_History_Error = (error) => {
  return {
    type: RENAME_TITLE_EDIT_HISTORY_ERROR,
    error: error,
  };
};

export const Rename_Title_edit_History_Request = (res) => {
  return {
    type: RENAME_TITLE_EDIT_HISTORY_REQUEST,
    payload: res,
  };
};

export const Rename_Title_edit_History_Action_Handler = (
  value,
  QaID,
  ActionId,
  historyId
) => {
  return (dispatch) => {
    dispatch(Rename_Title_edit_History_Request());
    try {
      Rename_Title_Edit_history_Api(value, QaID, ActionId, historyId)
        .then((res) => {
          const errorMessage = res?.data?.message;
          if (res) {
            if (res && res.data && res.status === 200) {
              dispatch(Rename_Title_edit_History_Success(res.data));
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Successfully Updated",
                showConfirmButton: false,
                timer: 1500,
              });
            } else {
              dispatch(Rename_Title_edit_History_Error(errorMessage));
            }
          } else {
            dispatch(Rename_Title_edit_History_Error(errorMessage));
          }
        })
        .catch((err) => {
          dispatch(Rename_Title_edit_History_Error("Something Went Wrong!!!"));
        });
    } catch (err) {
      dispatch(Rename_Title_edit_History_Error(err));
    }
  };
};
